import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import { stationStatus } from '../constants';

const cleanStation = {

  id: "",
  name: "",
  projectName: "",
  description: "",
  stationConfigId: "",
  location: "",
  country: "",
  city: "",
  longitude: 0,
  latitude: 0,
  status: stationStatus.active,
  refslowdatajson: "",
  refcapacitydatajson: "",
  reffastdatajson: "",
}

const station = (state = cleanStation, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STATION_SUCCESS:
      return action.station;
    case actionTypes.ADD_NEW_STATION:
      return {
        ...cleanStation
      };
    case actionTypes.SELECT_STATION:
      return {
        ...action.station
      };
    case actionTypes.SET_ID:
      return {
        ...state,
        id: action.id
      };
    case actionTypes.SET_NAME:
      return {
        ...state,
        name: action.name
      };
    case actionTypes.SET_PROJECT_NAME:
      return {
        ...state,
        projectName: action.projectName
      };
    case actionTypes.SET_DESCRIPTION:
      return {
        ...state,
        description: action.description
      };
    case actionTypes.SET_STATION_CONFIG:
      return {
        ...state,
        stationConfigId: action.stationConfig.id
      };
    case actionTypes.SET_LOCATION:
      return {
        ...state,
        location: action.location
      };
    case actionTypes.SET_COUNTRY:
        return {
          ...state,
          country: action.country
        };
    case actionTypes.SET_CITY:
        return {
          ...state,
          city: action.city
        };
    case actionTypes.SET_LONGITUDE:
      return {
        ...state,
        longitude: action.longitude
      };
    case actionTypes.SET_LATITUDE:
      return {
        ...state,
        latitude: action.latitude
      };
    case actionTypes.SET_REF_SLOW_DATA:
      return {
        ...state,
        refslowdatajson: action.refslowdatajson
      };
    case actionTypes.SET_REF_CAPACITY_DATA:
      return {
        ...state,
        refcapacitydatajson: action.refcapacitydatajson
      };
    case actionTypes.SET_REF_FAST_DATA:
      return {
        ...state,
        reffastdatajson: action.reffastdatajson
      };
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.RESTORE_STATION_SUCCESS:
      return {
        ...state,
        status: action.status
      }
    default:
      return state;
  }
}

const graphReferences = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return [];
    case actionTypes.FETCH_GRAPH_REFERENCE_SUCCESS:
      return action.graphReferences;
    case actionTypes.ADD_GRAPH_REFERENCE:
      return [
        ...state,
        action.graphReference
      ];
    case actionTypes.REMOVE_GRAPH_REFERENCE:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1)
      ];
    default:
      return state;
  }
}

const idError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_ID:
      return action.idError;
    case actionTypes.ADD_NEW_STATION:
      return "";
    default:
      return state;
  }
}

const snackBarMessage = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CREATE_STATION_FAILURE:
    case actionTypes.CREATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_FAILURE:
    case actionTypes.ARCHIVE_STATION_FAILURE:
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.RESTORE_STATION_FAILURE:
    case actionTypes.RESTORE_STATION_SUCCESS:
      console.log(action.message)
      return action.message;
    default:
      return state;
  }
}

const openDisabledConfirmation = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_DISABLED_CONFIRMATION:
      return !state;
    case actionTypes.ARCHIVE_STATION_REQUEST:
      return false;
    default:
      return state;
  }
}

const selectedFieldName = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_FIELD_NAME:
      return action.fieldName;
    default:
      return state;
  }
}

const selectedAgg = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_AGG:
      return action.agg;
    default:
      return state;
  }
}

const isAlertDialogOpened = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_ALERT_DIALOG:
      return !state;
    default:
      return state;
  }
}

const openedSnackBar = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STATION_FAILURE:
    case actionTypes.CREATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_FAILURE:
    case actionTypes.ARCHIVE_STATION_FAILURE:
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.RESTORE_STATION_FAILURE:
    case actionTypes.RESTORE_STATION_SUCCESS:
      return true
    case actionTypes.CLOSE_SNACK_BAR:
    case actionTypes.ADD_NEW_STATION:
    case actionTypes.SELECT_STATION:
      return false;
    default:
      return state;
  }
}

const actionStatus = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STATION_SUCCESS:
    case actionTypes.UPDATE_STATION_SUCCESS:
    case actionTypes.ARCHIVE_STATION_SUCCESS:
    case actionTypes.RESTORE_STATION_SUCCESS:
      return true;
    case actionTypes.RESET_ACTION_STATUS:
      return false;
    default:
      return state;
  }
}


export default combineReducers({
  station,
  idError,
  snackBarMessage,
  openDisabledConfirmation,
  graphReferences,
  selectedFieldName,
  selectedAgg,
  isAlertDialogOpened,
  openedSnackBar,
  actionStatus
});

const getCurrentState = state => state.stations.stationScreen;

export const getStation = state => getCurrentState(state).station

export const getIdError = state => getCurrentState(state).idError

export const getIsValid = state => {
  const { station } = getCurrentState(state);

  return (station.id) ?
    station.name && station.longitude && station.latitude :
    station.name && station.longitude && station.latitude && station.refslowdatajson && station.refcapacitydatajson && station.reffastdatajson
    ;
}

export const getSnackBarMessage = state => getCurrentState(state).snackBarMessage

export const getOpenDisabledConfirmation = state => getCurrentState(state).openDisabledConfirmation

export const getGraphReferences = state => getCurrentState(state).graphReferences;

export const getSelectedFieldName = state => getCurrentState(state).selectedFieldName;

export const getSelectedAgg = state => getCurrentState(state).selectedAgg;

export const getIsAlertDialogOpened = state => getCurrentState(state).isAlertDialogOpened;

export const getOpenedSnackBar = state => getCurrentState(state).openedSnackBar;

export const getActionStatus = state => getCurrentState(state).actionStatus